import { createSelector } from 'reselect'

const getMessagesState = state => state.messages;
const getIds = createSelector(getMessagesState, messages => messages.ids);
const getById = createSelector(getMessagesState, messages => messages.entities);

export const getMessages = createSelector(
  [getById, getIds], (entities, ids) => ids.map(id => entities[id])
);
